import { fetch } from '../hooks/use-fetch';

// Data => { clientId, language(active language)}
export const changeLanguageOnServer = async (data, auth) => {
  return await fetch.post('/changeLanguage', {
    body: JSON.stringify(data)
  }, auth)
}